import { GeneratePDFPayload } from "../../../types/pdf/GeneratePDFPayload";
import { API_REQUEST, DELETE_FILE, GET_FILE } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const generatePDF = (payload: GeneratePDFPayload): AppAction => ({
    type: API_REQUEST,
    payload: Object.assign({
        url: `/income/generate-pdf`,
        next: GET_FILE,
        data: { "propertyCode": sessionStorage.getItem("propertyCode") as string, ...payload },
        method: 'POST',
        authorization: true
    })
});

export const getFile = (folderKey: string, snapshotId: string, fileName: string, campaignStatusCode: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/snapshots/${snapshotId}/files/${folderKey}/${fileName}/${campaignStatusCode}`,
        next: GET_FILE,
        method: 'GET',
        authorization: true
    }
})

export const deleteFile = (folderKey: string, snapshotId: string, fileName: string, campaignStatusCode: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/snapshots/${snapshotId}/files/${folderKey}/${fileName}/${campaignStatusCode}`,
        next: DELETE_FILE,
        method: 'DELETE',
        authorization: true
    }
})